import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Input from './Input.js';
import Submit from './Submit.js';
import Select from './Select.js';
import Textarea from './Textarea.js';
import Checkbox from './Checkbox.js';
import { StyledForm } from './styles.js';
import onSubmit from '../formOnSubmit.js';
import { jsx as ___EmotionJSX } from "@emotion/react";

var prevent = function prevent(e) {
  return e.preventDefault();
};

var spamFilter = ___EmotionJSX("label", {
  style: {
    height: 0,
    left: 0,
    opacity: 0,
    position: 'absolute',
    top: 0,
    width: 0,
    zIndex: -1
  }
}, ___EmotionJSX("input", {
  type: "checkbox",
  name: "contact_me_by_fax_only",
  value: "1",
  tabIndex: "-1",
  autoComplete: "off"
}));

export function Form(props) {
  return ___EmotionJSX(StyledForm, _extends({
    id: props.name,
    action: process.env.FORM_API + (props.action || ''),
    method: props.method || 'POST',
    noValidate: !process.env.ENV_RAW,
    className: props.className,
    onSubmit: process.env.ENV_RAW ? onSubmit : prevent,
    style: props.style,
    layout: props.layout
  }, process.env.ENV_RAW ? null : props.uiEvents), props.fields.map(function (field, index) {
    var id = props.name + '-' + index;

    switch (field.type) {
      case 'textarea':
        return ___EmotionJSX(Textarea, _extends({
          key: index,
          id: id
        }, field, {
          disabled: props.edit
        }));

      case 'submit':
        return ___EmotionJSX(Submit, _extends({
          key: index
        }, field, {
          disabled: props.edit
        }));

      case 'checkbox':
        return ___EmotionJSX(Checkbox, _extends({
          key: index
        }, field, {
          disabled: props.edit
        }));

      case 'select':
        return ___EmotionJSX(Select, _extends({
          key: index
        }, field, {
          disabled: props.edit
        }));

      default:
        return ___EmotionJSX(Input, _extends({
          key: index,
          id: id
        }, field, {
          disabled: props.edit
        }));
    }
  }), spamFilter, process.env.SITE_ID ? ___EmotionJSX("input", {
    type: "hidden",
    name: "site_id",
    value: process.env.SITE_ID
  }) : null, props.children);
}